import {Component, inject} from '@angular/core';
import {RouterContextDirective} from '@core/directives/router-context.directive';
import {CookiebotLoaderService} from '@core/services/cookiebot-loader.service';
import {environment} from '@env/environment';

@Component({
  selector: 'app-footer-info-and-links',
  templateUrl: './footer-info-and-links.component.html',
  styleUrl: './footer-info-and-links.component.scss',
  imports: [
    RouterContextDirective
  ]
})
export class FooterInfoAndLinksComponent {

  private cookiebotLoaderService = inject(CookiebotLoaderService);

  showOnDK = environment.locale === 'da-DK';
  showB2B = environment.supervin.showB2B;

  openCookieSettings(): void {
    this.cookiebotLoaderService.openConsentDialog();
  }
}
